const THEME_KEY = 'app_theme'

export function getThemeFromLocal() {
  try {
    return localStorage.getItem(THEME_KEY)
  } catch {
    return null
  }
}

export function saveThemeToLocal(theme) {
  try {
    localStorage.setItem(THEME_KEY, theme)
  } catch {
    // localStorage unavailable
  }
}

export function initTheme(store) {
  const cached = getThemeFromLocal() || 'light'
  document.documentElement.setAttribute('data-theme', cached)
  store.dispatch('theme/switchTheme', cached)
}
